import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';
import UserControls from 'flarum/common/utils/UserControls';
import Button from 'flarum/common/components/Button';

import AuditModal from '../components/AuditModal';

const translationPrefix = 'kilowhat-audit.forum.user_controls.';

export default () => {
    add_audit_for_user_controls();
}

function add_audit_for_user_controls() {
    extend(UserControls, 'userControls', function (items, user) {
        if (user.canViewAudit()) {
            items.add(
                'audit_as_user',
                <Button icon="fas fa-book" onclick={() => app.modal.show(AuditModal, { baseQ: `user:${user.username()}` })}>
                    {app.translator.trans(translationPrefix + 'audit_as_user_button')}
                </Button>
            );

            items.add(
                'audit_as_actor',
                <Button icon="fas fa-book" onclick={() => app.modal.show(AuditModal, { baseQ: `actor:${user.username()}` })}>
                    {app.translator.trans(translationPrefix + 'audit_as_actor_button')}
                </Button>
            );
        }
    });
}
